import Lenis from "lenis";

let lenis = null;
let rafId = null;

export const destroySmoothScroll = () => {
  if (rafId) cancelAnimationFrame(rafId);
  lenis?.destroy();
  lenis = null;
  rafId = null;
};

export const initSmoothScroll = () => {
  if (lenis) return destroySmoothScroll;
  lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  const raf = (time) => {
    lenis.raf(time);
    rafId = requestAnimationFrame(raf);
  };
  rafId = requestAnimationFrame(raf);
  return destroySmoothScroll;
};

export const scrollToSection = (e, target) => {
  if (e) e.preventDefault();
  if (lenis) {
    lenis.scrollTo(target, { offset: -76, duration: 1.4 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};
